// extracted by mini-css-extract-plugin
module.exports = {"Skill":"Skill_Skill__24wlY","RemoveBtn":"Skill_RemoveBtn__SPCgK"};